import styled from 'styled-components'

const Wrapper = styled.section`
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  .btn-container {
    background: var(--primary-100);
    border-radius: var(--borderRadius);
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
  }

  .btn-row{
    display: flex;
    flex-direction: row;
  }

  .monthBtn {
    background: transparent;
    border-color: transparent;
    height: 40px;
    width: 100%;
    font-weight: 700;
    font-size: 1.1rem;
    color: var(--primary-500);
    transition: var(--transition);
    border-radius: var(--borderRadius);
    cursor: pointer;
  }

  .monthBtn: hover{
    background: var(--primary-500);
    color: var(--white);
  }

  .active {
    background: var(--primary-500);
    color: var(--white);
  }
`
export default Wrapper
